import React, { useState } from 'react'
import axios from 'axios'
import { Modal, message, Button } from 'antd'
import MyInput from '../../../components/forms/input'
import MyImageUpload from '../../../components/forms/imageUpload'
import MySwitch from '../../../components/forms/switch'

const AddSecondaryColumn = (props) => {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [formValue, setFormValue] = useState({})
  const [errorMsg, setErrorMsg] = useState({})

  const handleSubmit = () => {
    setErrorMsg({})
    if (!formValue.name) {
      setErrorMsg({nameEmpty: '栏目名称不能为空'})
      return false
    }

    axios.post('/p/content/column/add', {
      merchant_oid: merchantOid,
      name: formValue.name,
      category: props.data.category,
      superior_column_oid: props.data.superior_column_oid,
      sort: Number(formValue.sort),
      icon: formValue.icon,
      is_hide: formValue.is_hide
    })
      .then(function (response) {
        if (response.errcode === 0) {
          message.success(`新建${props.data.name}栏目成功！`)
          props.getCollegeList()
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  const handleOk = () => {
    const isOk = handleSubmit()
    if (isOk !== false) {handleCancel()}
  }

  const handleNext = () => {
    handleSubmit()
    setFormValue({})
  }

  const handleCancel = () => {
    setErrorMsg({})
    setFormValue({})
    props.isCancel()
  }

  return (
    <>
      <Modal
        destroyOnClose={true}
        title={`添加《${props.data.superior_column_name}》的子栏目`}
        width='460px'
        open={props.isOpen}
        onCancel={handleCancel}
        maskClosable={false}
        footer={[
          <Button key='cancel' onClick={handleCancel}>取消</Button>,
          <Button key='submit' onClick={handleNext}>提交并新建下一条</Button>,
          <Button key='isOk' type="primary" onClick={handleOk}>创建</Button>
        ]}>

        <MyImageUpload 
          id="icon"
          label='图标'
          value={formValue.icon}
          setValue={setFormValue}
        />

        <MyInput
          id="name"
          required
          autoFocus
          maxLength={64}
          label='名称'
          placeholder='请输入栏目的名称'
          value={formValue.name}
          onChange={setFormValue}
          errorMsg={errorMsg.nameEmpty}
        />

        <MySwitch 
          id='is_hide'
          label='是否隐藏'
          onChange={setFormValue}
        />

        <MyInput
          type='number'
          id="sort"
          label='排序'
          value={formValue.sort}
          onChange={setFormValue}
          styles={{ width: '60px' }}
          min={0}
          max={1000}
        />
      </Modal>
    </>
  )
}

export default AddSecondaryColumn
